import { Object3D } from 'three';

export const symmetry_plane_name = 'symmetry_plane';

export function is_symmetry_plane(x: Object3D) {
    return x.name === symmetry_plane_name;
}
